import React, { useEffect, useState } from "react";
import "./mediumPosts.css";

const MediumPosts = () => {
    const [posts, setPosts] = useState([]);
    const mediumUsername = "prabindrasapkota"; // Medium username
    const mediumProfile = `https://medium.com/@${mediumUsername}`; // Profile link

    useEffect(() => {
        const fetchMediumPosts = async () => {
            try {
                const response = await fetch(
                    `https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@${mediumUsername}`
                );
                const data = await response.json();
                setPosts(data.items.slice(0, 4)); // Show latest 4 posts
            } catch (error) {
                console.error("Error fetching Medium posts:", error);
            }
        };
        fetchMediumPosts();
    }, []);

    return (
        <section id="medium" className="py-12 md:py-16 lg:py-20" style={{background: 'rgba(var(--bg-dark), 0.06)'}}>
            <div className="max-w-6xl mx-auto px-3 md:px-4">
                <h1 className="pixel-title text-center text-2xl sm:text-3xl md:text-4xl mb-8 md:mb-12" style={{color: 'rgb(var(--primary-accent))'}}>TECH JOURNAL</h1>

                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
                    {posts.map((post, index) => (
                        <article key={index} className="post-card hud-panel p-3 md:p-4 rounded-sm" style={{background: 'rgba(var(--bg-dark), 0.5)', border: '2px solid rgba(var(--primary-accent), 0.18)'}}>
                            <h3 className="post-title arcade-title text-xs sm:text-sm md:text-base" style={{color: 'rgb(var(--primary-accent))'}}>{post.title}</h3>
                            <p className="post-description text-gray-300 mt-2 text-xs sm:text-sm leading-relaxed">
                                {post.description.replace(/<[^>]*>/g, "").substring(0, 200)}...
                            </p>
                            <a href={post.link} target="_blank" rel="noopener noreferrer" className="inline-block mt-2 md:mt-3 text-xs sm:text-sm transition-colors" style={{color: 'rgb(var(--primary-accent))'}}>
                                Read More →
                            </a>
                        </article>
                    ))}
                </div>

                <div className="mt-6 md:mt-8 text-center">
                    <a href={mediumProfile} target="_blank" rel="noopener noreferrer" className="inline-block px-3 md:px-4 py-2 rounded-sm arcade-title text-xs sm:text-sm md:text-base transition-colors" style={{background: 'rgba(var(--primary-accent),0.08)', color: 'rgb(var(--primary-accent))', border: '1px solid rgba(var(--primary-accent),0.18)'}}>
                        DECODE MY INSIGHTS
                    </a>
                </div>
            </div>
        </section>
    );
};

export default MediumPosts;
